/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-wrap-multilines */
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useLifecycles, useUpdateEffect } from 'react-use';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import PhotoModal from '../../components/photo/PhotoModal';
import ListToggleButtonGroup from '../../components/ListToggleButtonGroup';
import {
  LIST_FILTERS,
  LIST_SORTS,
  PHOTO_STATUS_VIEW_LIST_LENGTHS,
} from '../../common/consts';
import { deleteItem, getData, init } from '../../modules/photoBot';
import Toast from '../../components/Toast';
import PhotoItem from '../../components/photo/PhotoItem';

const initialModal = { open: false, items: [] };

const PhotoStatusContainer = ({ bManagerMode }) => {
  const dispatch = useDispatch();
  const {
    loading,
    lists,
    total,
    listLength,
    delete: { result: deleted, photo: deletePhoto },
  } = useSelector((state) => state.photoBot);

  const smMatches = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const lgMatches = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const [modal, setModal] = useState({ ...initialModal });
  const [filter, setFilter] = useState('date');
  const [selected, setSelected] = useState([]);
  const [[page, sort], setPage] = useState([0, 'desc']);
  const [delSnack, setDelSnack] = useState(null);
  const rowsPerPage = PHOTO_STATUS_VIEW_LIST_LENGTHS[0].value;
  const from = total > 0 ? page * rowsPerPage : 0;
  const to =
    total > (page + 1) * rowsPerPage ? (page + 1) * rowsPerPage : total;

  useLifecycles(
    () => {
      dispatch(
        getData({
          filter,
          desc: sort === 'desc',
          limit: rowsPerPage,
          skip: from,
        }),
      );
    },
    () => {
      dispatch(init());
    },
  );

  useUpdateEffect(() => {
    if (deleted) {
      setDelSnack(true);
      dispatch(
        getData({
          filter,
          desc: sort === 'desc',
          limit: listLength < 101 ? listLength : rowsPerPage,
          skip: 0,
        }),
      );
    }
  }, [deleted]);
  useUpdateEffect(() => {
    dispatch(
      getData({
        filter,
        desc: sort === 'desc',
        limit: listLength < 101 ? listLength : rowsPerPage,
        skip: 0,
      }),
    );
  }, [filter]);

  useUpdateEffect(() => {
    dispatch(
      getData({
        filter,
        desc: sort === 'desc',
        limit: rowsPerPage,
        skip: from,
      }),
    );
  }, [page, sort]);

  const onItemFilterChange = (e, v) => {
    if (v) {
      setFilter(v);
    }
  };

  const onItemSortChange = (e, v) => {
    if (v) {
      setPage([0, v]);
    }
  };

  const handleDeleteErrorClose = () => {
    setDelSnack(false);
  };

  const selectItem = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleDeleteClick = () => {
    if (selected.length) {
      setModal({
        open: true,
        items: selected,
        onClose: () => setModal({ ...initialModal }),
        onUpdate: () => {
          dispatch(deleteItem(selected));
          setSelected([]);
          setModal({ ...initialModal });
        },
      });
    }
  };

  const handleMoreClick = () => {
    setPage([page + 1, sort]);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6} alignSelf="center" sx={{ mb: 1 }}>
          <Typography>
            {`${total ? 1 : 0} - ${to} 개 / 총 ${total}개`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 1 }}>
          <Stack direction="row" gap={1} justifyContent="end">
            {!bManagerMode && (
              <ListToggleButtonGroup
                {...{
                  label: '필터',
                  name: 'filter',
                  value: filter,
                  onChange: onItemFilterChange,
                  list: LIST_FILTERS,
                }}
              />
            )}
            <ListToggleButtonGroup
              {...{
                label: '정렬',
                name: 'sort',
                value: sort,
                onChange: onItemSortChange,
                list: LIST_SORTS,
              }}
            />
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={handleDeleteClick}
              disabled={selected.length === 0}
            >
              선택 삭제
            </Button>
          </Stack>
        </Grid>
        {total ? (
          lists.map((listitem) => {
            const [[k, items]] = Object.entries(listitem);
            return (
              <Grid item container key={k} widths={12} sx={{ mb: 2 }}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    {filter === 'date' &&
                      moment(new Date(k)).calendar({
                        sameDay: '[오늘]',
                        lastDay: '[어제]',
                        lastWeek: '[지난] dddd',
                        sameElse: 'YYYY.MM.DD',
                      })}
                    {filter !== 'date' && k}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 2,
                      rowGap: 2,
                      gridTemplateColumns: `repeat(${
                        smMatches ? 1 : lgMatches ? 4 : 3
                      }, 1fr)`,
                      my: '1em',
                    }}
                  >
                    {items.map((item) => (
                      <Card key={item.id}>
                        <CardContent
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%',
                          }}
                        >
                          <Stack direction="row" alignItems="start">
                            <Checkbox
                              name="check"
                              color="secondary"
                              onChange={() => selectItem(item.id)}
                              sx={{ py: 0.5, pl: 0, pr: 1 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{ wordBreak: 'keep-all' }}
                            >
                              {moment(new Date(item.date)).format('LLL')}
                            </Typography>
                          </Stack>
                          <Stack
                            gap={2}
                            sx={{ position: 'relative', ml: 3, mt: 2 }}
                          >
                            <PhotoItem photo={item.photo} />
                            <Stack>
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={2}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.disabled"
                                  sx={{ width: 34 }}
                                >
                                  시리얼
                                </Typography>
                                <Typography>{item.serial}</Typography>
                              </Stack>
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={2}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.disabled"
                                  sx={{ width: 34 }}
                                >
                                  닉네임
                                </Typography>
                                <Typography>{item.alias || '-'}</Typography>
                              </Stack>
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={2}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.disabled"
                                  sx={{ width: 34, letterSpacing: 10 }}
                                >
                                  그룹
                                </Typography>
                                <Typography>{item.group}</Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Grid>
              </Grid>
            );
          })
        ) : (
          <Grid item xs={12}>
            {!loading && <Typography>등록된 사진이 없습니다.</Typography>}
          </Grid>
        )}
        {total > to && (
          <Grid item xs={12} sx={{ my: 3 }}>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleMoreClick}
              fullWidth
            >
              {loading ? <CircularProgress /> : '더보기'}
            </Button>
          </Grid>
        )}
      </Grid>
      <PhotoModal {...{ ...modal }} />
      <Toast
        {...{
          open: !!(delSnack && deletePhoto),
          onClose: handleDeleteErrorClose,
          message: deletePhoto,
          severity: deleted ? 'success' : 'error',
        }}
      />
    </>
  );
};

export default PhotoStatusContainer;
